<template>
  <a-space v-if="user">
    <UserAvatar :avatar-url="user.avatarUrl||''" />
    {{ user.nickname || user.name }}
    <template v-if="!isMyself">
      <StarFilled
        v-if="followingUserIds.includes(user.id)"
        class="icon-block following-icon"
        @click="unfollowUser"
      />
      <StarTwoTone
        v-else
        two-tone-color="#FFBF55"
        class="icon-block following-icon"
        @click="followUser"
      />
    </template>
  </a-space>
</template>

<script>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'
import { useI18n } from 'vue-i18n'
import { StarTwoTone, StarFilled } from '@ant-design/icons-vue'
import { message } from 'ant-design-vue'

import { getUser } from '@/graphql/user'
import { follow, unfollow } from '@/api/user'
import UserAvatar from '@/components/UserAvatar'

export default {
  components: {
    StarTwoTone,
    StarFilled,
    UserAvatar
  },
  setup () {
    const route = useRoute()
    const store = useStore()
    const { t } = useI18n()

    const userId = route.params.userId && +route.params.userId
    const isMyself = !userId
    const user = ref(null)
    const followingUserIds = computed(() => store.getters.followingUserIds)
    let isLoading = false

    if (userId) {
      getUser(userId)
        .then(data => {
          user.value = data
        })
    } else {
      user.value = store.state.user
    }

    function followUser () {
      if (isLoading) {
        return
      }
      isLoading = true
      follow(user.value.id)
        .then(() => {
          store.dispatch('login')
          message.success(t('okr.toolbar.followSuccessMessage'))
        })
        .finally(() => {
          isLoading = false
        })
    }

    function unfollowUser () {
      if (isLoading) {
        return
      }
      isLoading = true
      unfollow(user.value.id)
        .then(() => {
          store.dispatch('login')
          message.success(t('okr.toolbar.unfollowSuccessMessage'))
        })
        .finally(() => {
          isLoading = false
        })
    }

    return {
      user,
      followingUserIds,
      isMyself,
      followUser,
      unfollowUser
    }
  }
}
</script>

<style lang="less" scoped>
.following-icon {
  font-size: 22px;
  color: #FFBF55;
}
</style>
